import * as types from '../constants';

const initialState = {
  floorListTotal: 0,
  floorListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 10,
  },
  filterItem: {
    buildingId: '',
  },
};

const FloorListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_FLOOR_LIST_STATE:
      return {
        ...state,
        floorListTotal: 0,
        floorListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        filterItem: {
          buildingId: '',
        },
      };
    case types.SET_FLOOR_LIST:
      return {
        ...state,
        floorListTotal: action.payload.total,
        floorListItems: action.payload.items,
      };
    case types.SET_FLOOR_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_FLOOR_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_FLOOR_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default FloorListReducer;